import React from 'react';
import { Box, Typography } from '@mui/material';
import DummyBadge from '../../common/DummyBadge';
import { cardSx } from './styles';
import { useCardReveal } from './motion';

const DEMO = 'Demo data — waits for the dashboard backend';

/** Card shell: title (+count chip, D), optional link; shows an inline error or "No data yet" instead of its content. */
const DashCard = ({ title, count, linkLabel, onLink, demo, error, empty, emptyText = 'No data yet', sx, children }) => {
  const reveal = useCardReveal();
  return (
  <Box sx={{ ...cardSx, ...sx, ...reveal }}>
    {(title || linkLabel) && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 700 }}>{title}</Typography>
        {count != null && (
          <Box component="span" sx={{ fontSize: '0.6875rem', fontWeight: 700, px: 1, py: 0.25, borderRadius: 999, bgcolor: 'warning.light', color: 'warning.contrastText' }}>
            {count}
          </Box>
        )}
        {demo && <DummyBadge label={DEMO} />}
        {linkLabel && (
          <Typography component="button" type="button" onClick={onLink}
            sx={{ ml: 'auto', border: 0, bgcolor: 'transparent', p: 0, cursor: 'pointer', font: 'inherit', fontSize: '0.75rem', fontWeight: 600, color: 'primary.main', whiteSpace: 'nowrap' }}>
            {linkLabel}
          </Typography>
        )}
      </Box>
    )}
    {error ? (
      <Typography sx={{ fontSize: '0.75rem', color: 'error.main' }}>{error}</Typography>
    ) : empty ? (
      <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>{emptyText}</Typography>
    ) : children}
  </Box>
  );
};

export default DashCard;
